import type { UseCountryReturn } from "~/v2/api/hooks/useCountry";
import type { Account, Owner, OwnerDetails } from "~/v2/api/rest/account";
import type { Billing } from "~/v2/api/rest/billing";
import type { ElitePerks } from "~/v2/api/rest/elite";
import { OnboardingLayout } from "~/v2/components/OnboardingLayout";
import type { MarketDataPlans } from "../util";
import type { SubscribeStep } from "./Subscribe.controller";
import type { PaymentSchedule } from "./types";

interface SubscribePresentationProps {
  account: Account | undefined;
  details: OwnerDetails | undefined;
  isLegalEntity: boolean;
  legalEntityOwner: Owner | undefined;
  accountOpener: Owner | undefined;
  elitePerks: ElitePerks | undefined;
  billing: Billing | undefined;
  plans: MarketDataPlans | undefined;
  country: UseCountryReturn;
  isSubscribed: boolean;
  isElite: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onBackToPreviousStep: () => void;
  onContinueToNextStep: () => void;
  onPaymentScheduleChange: (paymentSchedule: PaymentSchedule) => void;
  paymentSchedule: PaymentSchedule;
  step: SubscribeStep | undefined;
  totalSteps: number | undefined;
}

export const SubscribePresentation = ({
  account,
  details,
  elitePerks,
  billing,
  plans,
  isSubscribed,
  isElite,
  isLoading,
  onCancel,
  onBackToPreviousStep,
  onContinueToNextStep,
  onPaymentScheduleChange,
  paymentSchedule,
  step,
  totalSteps,
  country,
  isLegalEntity,
  legalEntityOwner,
  accountOpener,
}: SubscribePresentationProps) => {
  const StepComponent = step?.component;

  return (
    <div className="bg-gray-50">
      <OnboardingLayout
        title={step?.title}
        description={step?.description}
        titleTooltip={step?.titleTooltip}
        currentStep={step?.step}
        totalSteps={totalSteps}
        isLoading={isLoading}
        onCancel={onCancel}
        containerClassNames="max-w-[800px] pb-44"
      >
        {account && details && plans && StepComponent && (
          <StepComponent
            account={account}
            details={details}
            elitePerks={elitePerks}
            billing={billing}
            plans={plans}
            isSubscribed={isSubscribed}
            isElite={isElite}
            onBackToPreviousStep={onBackToPreviousStep}
            onContinueToNextStep={onContinueToNextStep}
            onPaymentScheduleChange={onPaymentScheduleChange}
            paymentSchedule={paymentSchedule}
            isLoading={isLoading}
            onCancel={onCancel}
            country={country}
            isLegalEntity={isLegalEntity}
            legalEntityOwner={legalEntityOwner}
            accountOpener={accountOpener}
          />
        )}
      </OnboardingLayout>
    </div>
  );
};
